import React from 'react';
import { Menu, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

interface HeaderProps {
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (isOpen: boolean) => void;
}

const Header: React.FC<HeaderProps> = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {
  const { t } = useTranslation();

  return (
    <header className="fixed w-full bg-white/90 backdrop-blur-sm z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0 flex items-center">
            <h1 className="text-2xl font-bold text-[#222222]">FLEXORA</h1>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <a href="#products" className="text-[#555555] hover:text-[#1E3A8A] transition-colors">
              {t('navigation.products')}
            </a>
            <a href="#where-to-buy" className="text-[#555555] hover:text-[#1E3A8A] transition-colors">
              {t('navigation.whereToBuy')}
            </a>
            <LanguageSelector />
          </nav>

          <button
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6 text-[#222222]" />
            ) : (
              <Menu className="h-6 w-6 text-[#222222]" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white">
            <a
              href="#products"
              className="block px-3 py-2 text-[#555555] hover:text-[#1E3A8A]"
            >
              {t('navigation.products')}
            </a>
            <a
              href="#where-to-buy"
              className="block px-3 py-2 text-[#555555] hover:text-[#1E3A8A]"
            >
              {t('navigation.whereToBuy')}
            </a>
            <div className="px-3 py-2">
              <LanguageSelector />
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;